import { render, staticRenderFns } from "./feedback.vue?vue&type=template&id=8323e934&scoped=true&"
import script from "./feedback.vue?vue&type=script&lang=js&"
export * from "./feedback.vue?vue&type=script&lang=js&"
import style0 from "./feedback.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./feedback.vue?vue&type=style&index=1&id=8323e934&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8323e934",
  null
  
)

export default component.exports